import React from "react";
import { Stack, TextField } from "@mui/material";
import { Text } from "@imminently/react/ui/core/text";
import { FieldError } from "react-hook-form";
import { LAYOUT_CONFIG } from "./PatientNotesConstants";

interface PatientNotesNoteTitleRowProps {
  value: string;
  onChange: (value: string) => void;
  error?: FieldError;
  disabled?: boolean;
}

export const PatientNotesNoteTitleRow: React.FC<PatientNotesNoteTitleRowProps> = React.memo((p) => {
  const { value, onChange, error, disabled } = p;

  return (
    <Stack
      position="absolute"
      zIndex="1"
      top={LAYOUT_CONFIG.titleTop}
      left="1rem"
      right="2rem"
      direction="row"
      alignItems="center"
      gap="1rem"
    >
      <Text variant="subtitle1">Title</Text>

      <TextField
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant="standard"
        disabled={disabled}
        error={Boolean(error)}
        fullWidth
        sx={{
          maxWidth: "calc(100% - 60px)",
          "& .MuiInput-underline:before": {
            borderBottomColor: "rgba(0, 0, 0, 0.12)",
          },
          "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
            borderBottomColor: "rgba(0, 0, 0, 0.3)",
          },
        }}
      />

      {error && (
        <Text color="error" variant="caption">
          {error.message}
        </Text>
      )}
    </Stack>
  );
});

PatientNotesNoteTitleRow.displayName = "PatientNotesNoteTitleRow";
